import { __extends } from "tslib";
import { Event } from './Event';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: NetStatusEvent
var NetStatusEvent = /** @class */ (function (_super) {
    __extends(NetStatusEvent, _super);
    function NetStatusEvent(type, bubbles, cancelable, info) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (info === void 0) { info = null; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this._info = info;
        return _this;
    }
    Object.defineProperty(NetStatusEvent.prototype, "info", {
        get: function () {
            return this._info;
        },
        set: function (value) {
            this._info = value;
        },
        enumerable: true,
        configurable: true
    });
    NetStatusEvent.prototype.clone = function () {
        return new NetStatusEvent(this.type, this.bubbles, this.cancelable, this.info);
    };
    NetStatusEvent.prototype.toString = function () {
        return this.formatToString('NetStatusEvent', 'type', 'bubbles', 'cancelable', 'eventPhase', 'info');
    };
    NetStatusEvent.classInitializer = null;
    NetStatusEvent.classSymbols = null;
    NetStatusEvent.instanceSymbols = null;
    // JS -> AS Bindings
    NetStatusEvent.NET_STATUS = 'netStatus';
    return NetStatusEvent;
}(Event));
export { NetStatusEvent };
